import type { EntityType } from "@btnet/services-btnet/handlers/models/entityType";

export class EntityRecordLinkInfo {
    constructor(data: {
        sourceExternalId: string;
        sourceEntityType: number;
        targetExternalId: string;
        targetEntityType: number;
    }) {
        this.sourceExternalId = data.sourceExternalId;
        this.sourceEntityType = data.sourceEntityType as EntityType;
        this.targetExternalId = data.targetExternalId;
        this.targetEntityType = data.targetEntityType as EntityType;
    }

    sourceExternalId: string;
    sourceEntityType: EntityType;
    targetExternalId: string;
    targetEntityType: EntityType;
}
